import React from 'react'
import { Link } from 'react-router-dom'
import './NotFound.css'

export const NotFound: React.FC = () => {
  return (
    <div className="notFound">
      <div className="notFound__container">
        <h1 className="notFound__title">404</h1>
        <p className="notFound__message">Página no encontrada</p>
        <Link to="/" className="notFound__link">Volver a inicio</Link>
      </div>
    </div>
  )
}
